export const PATH = {
  COMPANY_LIST: 'company/list',
  COMPANY: 'company/',
  NEW_COMPANY: 'company/new',
  FILTERS_DATA: 'company/filtersData',
  COMPLETE_PROFILE: 'company/complete',
  PROFILE_FILTERS: 'company/filtersData',
  DOCUMENTS: 'company/documents',
  MIGRATION_CODE: 'migration/sendMigrationCode',
}
